module.exports = __webpack_public_path__ + "static/media/hero3.f6de3ea7.jpg";